var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-title-group" },
        [
          _c("h1", [_vm._v("GMB Manager")]),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: { click: _vm.openManageAccountsDialog }
            },
            [
              _c("i", { staticClass: "fa fa-user-circle" }),
              _vm._v(" Manage Accounts ")
            ]
          )
        ],
        1
      ),
      _c(
        "FilterPanel",
        [_c("SearchFilter", { on: { filter: _vm.doFilter } })],
        1
      ),
      _c(
        "MainPanel",
        [
          _c(
            "div",
            { staticClass: "action-bar" },
            [
              _c("PageLimitSwitcher", {
                attrs: { active: _vm.filterObject.per_page },
                on: { click: _vm.setPageLimit }
              }),
              _vm.list.length
                ? _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      "page-size": _vm.filterObject.per_page,
                      "current-page": _vm.filterObject.page,
                      total: _vm.list.total,
                      "hide-on-single-page": ""
                    },
                    on: { "current-change": _vm.changePage }
                  })
                : _vm._e(),
              _c("div", { staticClass: "table-total" }, [
                _vm._v(
                  " Total Items: " +
                    _vm._s((_vm.list.data && _vm.list.data.length) || "-") +
                    " "
                )
              ])
            ],
            1
          ),
          _c("GMBLocationsList", {
            attrs: { loading: _vm.loading, list: _vm.list },
            on: {
              edit: _vm.openEditLocationDialog,
              "refetch-data": _vm.getGmbLocations,
              sort: _vm.doSort
            }
          })
        ],
        1
      ),
      _c("EditLocationDialog", {
        attrs: { visible: _vm.editLocationDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.editLocationDialogVisible = $event
          },
          close: _vm.closeEditLocationDialog,
          "refetch-data": _vm.getGmbLocations
        }
      }),
      _c("ManageAccountsModal", {
        attrs: { visible: _vm.manageAccountsDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.manageAccountsDialogVisible = $event
          },
          close: _vm.closeManageAccountsDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }